import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasetNamespacesState from './datasetNamespaces';
import updateDatasetSettingsState from './datasetSettings';
import updateDatasetState from './dataset';

const handlers = {
  ...updateDatasetNamespacesState,
  ...updateDatasetSettingsState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
